import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";

/** /orders/no/:number — opens the job behind a BPR / MPWO or job number. */
export default function JobByNumber() {
  const { number } = useParams();
  const { search } = useLocation();
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    // A QR link from before the scan page: the details page for that job and stage, not the job.
    const stage = new URLSearchParams(search).get("stage");
    if (stage) { navigate(`/s/${encodeURIComponent(number)}?stage=${stage}`, { replace: true }); return undefined; }
    let cancelled = false;
    api
      .get(`/jobs/by-number/${encodeURIComponent(number)}`)
      .then(({ data }) => !cancelled && navigate(`/orders/${data.id}${search}`, { replace: true }))
      .catch((e) => !cancelled && setError(formatApiError(e)));
    return () => { cancelled = true; };
  }, [number, search, navigate]);

  return (
    <div className="p-8 text-sm">
      {error ? (
        <div className="border border-neutral-200 bg-white p-6 max-w-lg">
          <div className="font-medium text-neutral-900">{error}</div>
          <div className="text-neutral-500 mt-1">The number may belong to a job that hasn't been entered in the ERP yet.</div>
          <Link to="/orders" className="inline-block mt-4 text-[#FF5A00] hover:underline">All jobs →</Link>
        </div>
      ) : (
        <span className="label-caps">Opening {number}…</span>
      )}
    </div>
  );
}
